import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export const Button = ({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) => {
  const baseStyles = 'relative overflow-hidden font-cinzel font-semibold tracking-widest uppercase transition-all duration-300 flex items-center justify-center gap-2';
  const variants = {
    primary: 'bg-burgundy hover:bg-burgundy-light text-parchment border border-gold/50 hover:border-gold shadow-gold-glow hover:shadow-gold-glow-strong py-4 px-8 rounded-sm',
    secondary: 'bg-teal hover:bg-teal-light text-parchment border border-gold/30 hover:border-gold/80 py-3 px-6 rounded-sm',
    outline: 'bg-transparent border border-gold/40 hover:border-gold text-gold hover:text-gold-light py-3 px-6 rounded-sm hover:bg-gold/5'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthStyle} ${className}`} {...props} data-id="element-263">
      {/* Subtle inner glow effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-264" />

      <span className="relative z-10 flex items-center gap-2 text-shadow-engraved" data-id="element-265">
        {children}
      </span>
    </motion.button>;
};